import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setupAxiosInterceptors } from '../services/api';

const AxiosInterceptorSetup = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setupAxiosInterceptors(dispatch, navigate);
  }, [dispatch, navigate]);

  return children;
};

export default AxiosInterceptorSetup;
